
import {combineLatest as observableCombineLatest,  Observable, from } from 'rxjs';
import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
// Service
import { FormService } from '../../services/forms.service';
import { GlobalFlagsService } from '../../services/global-flags.service';
import { DialogService } from '../../services/dialog.service';
import { RequestHistoryService } from '../../services/requestHistory.service';
import { DialogComponent } from '../commons/dialog/dialog.component';
import { OAuthService } from '../../services/oauth.service';
import { LocationService } from '../../services/location.service';
import { StorageService } from '../../services/storage.service';
import { CookieService } from 'ngx-cookie';



// Model
import { FormData } from '../../models/formData';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class FormsComponent implements OnInit {



  constructor(private route: ActivatedRoute,
    private oAuthService: OAuthService,
    private router: Router,
    private formService: FormService,
    private dialog: MatDialog,
    private globalFlagsService: GlobalFlagsService,
    private dialogService: DialogService,
    private requestService: RequestHistoryService,
    private translate: TranslateService,
    private locationService: LocationService,
    private cookieService: CookieService,
    private storageService: StorageService,
    private cdRef: ChangeDetectorRef) { }

  private invalidForm: Array<boolean> = [];

  public formData: FormData = null;
  public buttonFinishDisabled: boolean = false;
  public _reload = true;


  formObj = null;
  errorOnAPI = false;
  formFinished = false;
  language: any;
  langCode: any;
  languages: any;
  languageName: any;
  languageId = Number(this.cookieService.get('formLanguage'));


  userDetails;

  get getLanguageId() {
    return this.languageId;
  }

  getFormPercentage() {
    return Math.round(this.formData.currentPageOrder * 100 / this.formData.totalPages);
  }

  get isPageInvalid() {
    return this.invalidForm.filter(invalid => {
      return invalid === true;
    })[0];
  }

  ngOnInit() {

    if (!sessionStorage.getItem('alreadyRefreshed')) {
      sessionStorage.setItem('alreadyRefreshed', 'true');
      location.reload();
    }

    const secUserLanguage = this.cookieService.get('formLanguage');
    this.locationService.setSecUserLanguage({languageId:secUserLanguage});
    const formId = this.cookieService.get('formId');
    const languages = from(this.locationService.getLanguages({formId: formId}));
    languages
      .subscribe((res) => {
        this.languages = res;
      });
    this.language = localStorage.getItem('lang');
    const obsComb = observableCombineLatest(this.route.params, this.route.queryParams,
      (params, qparams) => ({ params, qparams }));
    obsComb.subscribe(ap => {
      const formInstanceId = +ap.params.formInstanceId;
      const trackerSurvey = ap.qparams.trackerSurvey === 'true' ? true : false;
      this.getFormInstance(formInstanceId, trackerSurvey);
    });
    this.languageId = Number(this.cookieService.get('formLanguage'));

  }

  getFormInstance(formInstanceId: number, trackerSurvey: boolean) {
    if (localStorage.getItem('changedLanguage') == null) {
      localStorage.setItem('changedLanguage', OAuthService.getLanguage());
    }
       const formId = this.cookieService.get('formId');
    const languages = from(this.locationService.getLanguages({formId: formId}));
    languages
      .subscribe((res) => {
        this.languages = res;
      });
    this.language = this.cookieService.get('formLanguage');
    OAuthService.saveLanguage(localStorage.getItem('changedLanguage'));
    switch (this.cookieService.get('formLanguage')) {
      case '1':
        OAuthService.saveLanguageCode('EN');
        break;
      case '2':
        OAuthService.saveLanguageCode('ES');
        break;
      case '3':
        OAuthService.saveLanguageCode('ZH');
        break;
      case '4':
        OAuthService.saveLanguageCode('AR');
        break;
      case '5':
        OAuthService.saveLanguageCode('RU');
        break;
      case '6':
        OAuthService.saveLanguageCode('PL');
        break;
      case '7':
        OAuthService.saveLanguageCode('KO');
        break;
      default:
        OAuthService.saveLanguageCode('EN');
        break;
    }
    this.translate.use(OAuthService.getLanguageCode());
    this.globalFlagsService.displayLoad(true);
    this.cdRef.detectChanges();

    let form;
    if (trackerSurvey) {
      this.formService.startTrackerInstance({ id: formInstanceId });
    } else {
      form = from(this.formService.startInstance({ id: formInstanceId }));
      form
        .subscribe(
          (data) => {
            this.formObj = data;
            this.formData = new FormData(data);
            this.globalFlagsService.setFormName(this.formData.name);
            this.globalFlagsService.setFormLabel(this.formData.label);
            this.invalidForm = [];
            this.formData.formInstanceItem.forEach((element, index) => {
              this.invalidForm.push(false);
            });
            this.globalFlagsService.displayLoad(false);
          },
          err => {
            let error = err.json();
            if (error.errorCode === 'Not Valid') {
              this.errorOnAPI = true;
              this.globalFlagsService.displayLoad(false);
              this.router.navigate(['/']);
            }
            else {
              this.errorOnAPI = true;
              this.router.navigate(['/error']);
              throw err;
            }
          }
        );
    }
  }

  canDeactivate(): Observable<any> {
    let message: string;
    this.translate.get('Are you sure you want to exit?').subscribe((res: string) => {
      message = res;
    });
    const data = {
      message: message,
      cancelButton: true
    };

    return new Observable((observer) => {
      if (this.errorOnAPI || this.formFinished || !this.globalFlagsService.userLogged.value) {
        this.globalFlagsService.setFormName('');
        this.globalFlagsService.setFormLabel('');
        return observer.next(true);
      } else {
        const dialogRef = this.dialog.open(DialogComponent, { data });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.globalFlagsService.setFormName('');
            this.globalFlagsService.setFormLabel('');
            observer.next(true);
          } else {
            observer.next(false);
          }
        });
      }
    });
  }

  nextPage() {
    // If form is not valid, go top and do nothing
    OAuthService.saveLanguageCode("ES");
    OAuthService.saveLanguage(2);
    this.language = OAuthService.getLanguage();
    if (this.isPageInvalid) {
      window.scrollTo(0, 0);
      return;
    }
    this.globalFlagsService.displayLoad(true);
    this.deleteItems(this.formObj.formInstanceItem);
    const form = from(this.formService.nextPage(this.formObj));
    form
      .subscribe(
        (data) => {
          this.formObj = data;
          this.formData.updateFormData(data);
          this.invalidForm = [];
            this.formData.formInstanceItem.forEach((element, index) => {
            this.invalidForm.push(false);
          });
          this.globalFlagsService.displayLoad(false);
          window.scrollTo(0, 0);
        },
        err => {
          let message;
          this.translate.get('Connection Problems. Try again please').subscribe((res: string) => {
             message = res;
          });
          this.dialogService.openErrorDialog({ message });
          throw err;
        }
      );
  }

  prevPage() {
    this.globalFlagsService.displayLoad(true);
    this.deleteItems(this.formObj.formInstanceItem);
    const form = from(this.formService.prevPage(this.formObj));
    form
      .subscribe(
        (data) => {
          this.formObj = data;
          this.formData.updateFormData(data);
          this.invalidForm = [];
            this.formData.formInstanceItem.forEach((element, index) => {
            this.invalidForm.push(false);
          });
          this.globalFlagsService.displayLoad(false);
          window.scrollTo(0, 0);
        },
        err => {
          let message;
          this.translate.get('Connection Problems. Try again please').subscribe((res: string) => {
             message = res;
          });
          this.dialogService.openErrorDialog({ message });
          throw err;
        }
      );
  }

  finishForm() {
    this.buttonFinishDisabled = true;
    this.formObj.formInstanceLanguage=this.languageId;
    const formFinish = from(this.formService.finish(this.formObj));
    this.globalFlagsService.displayLoad(true);
    formFinish
      .subscribe(
        (res) => {
          this.formObj = res;
          this.formData.updateFormData(res);
          this.formFinished = true;
          this.globalFlagsService.setFormName('');
          this.globalFlagsService.setFormLabel('');
          this.globalFlagsService.displayLoad(false);
          if (this.formObj.urlReport != undefined && this.formObj.urlReport != "") {
            this.globalFlagsService.displayLoad(true);
            this.requestService.downloadPDF(this.formObj.urlReport, this.formObj.format)
            .subscribe(
              (res) => {
                this.downloadFile(res, '', this.formObj.format);
                this.globalFlagsService.displayLoad(false);
                this.router.navigate(['/']);
              }, (err) => {
                this.globalFlagsService.displayLoad(false);
                console.log('Server has encountered a problem. Sorry for inconvenience, we are working on it');
                let message;
                this.translate.get('Your submission has been accepted.').subscribe((res: string) => {
                  message = res;
                });
                this.globalFlagsService.pushSuccessAlert({ message });
                this.router.navigate(['/']);
              });
          }
          else {
            let message;
            this.translate.get('Your submission has been accepted.').subscribe((res: string) => {
              message = res;
            });
            this.globalFlagsService.pushSuccessAlert({ message });
            this.router.navigate(['/']);
          }
          this.buttonFinishDisabled = false;
          if (this.formObj.logoutFinish) {
            this.oAuthService.logout();
          }
          this.router.navigate(['/']);
        },
        err => {
          const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
          this.dialogService.openErrorDialog({ message: `${errMsg} Please try again.` });
          this.router.navigate(['/']);
          throw err;
        });
  }

  downloadFile(data: Blob, name: string, format: string) {
    name.replace('/', '-');
    if (window.navigator as any && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(data, data + "." + format);
    }
    else {
      let fileURL = URL.createObjectURL(data);
      window.location.href = fileURL;
    }
  }

  handleCallUpdate(event: any, formItem: any) {

    this.globalFlagsService.displayLoad(true);
    this.deleteItems(this.formObj.formInstanceItem);
    const form = from(this.formService.updateConditionals({ form: this.formObj, id: formItem.id }));
    form
      .subscribe(
        (data) => {
          this.formObj = data;
          this.formData.updateFormData(data);
          this.invalidForm = [];
            this.formData.formInstanceItem.forEach((element, index) => {
              this.invalidForm.push(false);
          });
          this.globalFlagsService.displayLoad(false);
        },
        err => {
          let message;
          this.translate.get('Connection Problems. Try again please').subscribe((res: string) => {
             message = res;
          });
          this.dialogService.openErrorDialog({ message });
          throw err;
         }
      );
  }

  // Recursive function. Deletes anything but 'value' and iterates over and over on 'formListInstanceItem' property
  deleteItems(formInstance) {
    formInstance.forEach((instance) => {
      for (const k in instance) {
        if (k !== 'value' && k !== 'boolValue' && k !== 'formListInstanceItem' && k !== 'id' && k !== 'item') {
          delete instance[k];
        } else if (k === 'formListInstanceItem' && instance[k] !== null) {
          this.deleteItems(instance.formListInstanceItem);
        }
      }
    });
  }


  changeLanguage() {
    this.cookieService.put('formLanguage', this.languageId.toString());
    OAuthService.saveLanguage(this.cookieService.get('formLanguage'));
    switch (this.cookieService.get('formLanguage')) {
      case '1':
        OAuthService.saveLanguageCode('EN');
        break;
      case '2':
        OAuthService.saveLanguageCode('ES');
        break;
      case '3':
        OAuthService.saveLanguageCode('ZH');
        break;
      case '4':
        OAuthService.saveLanguageCode('AR');
        break;
      case '5':
        OAuthService.saveLanguageCode('RU');
        break;
      case '6':
        OAuthService.saveLanguageCode('PL');
        break;
      case '7':
        OAuthService.saveLanguageCode('PL');
        break;
      default:
        OAuthService.saveLanguageCode('EN');
        break;
    }
    const secUserLanguage = this.cookieService.get('formLanguage');
    this.locationService.setSecUserLanguage({languageId:secUserLanguage});
    this.translate.use(OAuthService.getLanguageCode());
    this.reload();
  }



  private reload() {
    setTimeout(() => this._reload = false);
    setTimeout(() => this._reload = true);
  }
}
